import NavBar from "@/components/NavBar";
import SEOHead from "@/components/SEOHead";
import { Link } from "react-router-dom";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Política de Privacidad | CompresorJPEG"
        description="Política de privacidad de CompresorJPEG. Conoce cómo protegemos tus datos y tu privacidad al usar nuestro compresor de imágenes online."
        keywords="politica privacidad, privacidad compresor imagenes, datos personales"
        canonical="https://compresorjpeg.com/privacidad"
      />
      <NavBar />

      <main className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl font-bold text-foreground mb-8">Política de Privacidad</h1>
        <p className="text-sm text-muted-foreground mb-8">Última actualización: 17 de febrero de 2026</p>

        <div className="prose max-w-none space-y-6 text-muted-foreground">
          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">1. Información General</h2>
            <p>
              CompresorJPEG (<a href="https://compresorjpeg.com" className="text-primary hover:underline">compresorjpeg.com</a>) es una herramienta online gratuita para comprimir y optimizar imágenes. 
              Nos comprometemos a proteger tu privacidad y a ser transparentes sobre cómo manejamos la información.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">2. Procesamiento Local de Imágenes</h2>
            <p>
              <strong>Tus imágenes nunca salen de tu dispositivo.</strong> Todo el procesamiento de compresión y eliminación de fondo se realiza directamente en tu navegador web utilizando tecnologías de procesamiento local (JavaScript/WebAssembly). 
              No subimos, almacenamos ni tenemos acceso a tus imágenes en ningún momento.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">3. Datos que Recopilamos</h2>
            <h3 className="text-lg font-medium text-foreground mt-4 mb-2">3.1 Cuenta de usuario (opcional)</h3>
            <p>Si decides crear una cuenta, recopilamos:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Dirección de correo electrónico</li>
              <li>Nombre (si lo proporcionas)</li>
              <li>Historial de compresión (estadísticas, no imágenes)</li>
            </ul>

            <h3 className="text-lg font-medium text-foreground mt-4 mb-2">3.2 Datos analíticos anónimos</h3>
            <p>Recopilamos datos de uso anónimos para mejorar el servicio:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Número de compresiones realizadas</li>
              <li>Tipo de dispositivo (móvil/escritorio)</li>
              <li>Páginas visitadas</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">4. Pagos y Suscripciones</h2>
            <p>
              Los pagos se procesan a través de <strong>Stripe</strong>, un procesador de pagos certificado PCI-DSS. 
              No almacenamos información de tarjetas de crédito. Stripe maneja todos los datos de pago de forma segura.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">5. Cookies</h2>
            <p>Utilizamos cookies esenciales para:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Mantener tu sesión de usuario activa</li>
              <li>Recordar tus preferencias de compresión</li>
              <li>Análisis anónimo de uso del sitio</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">6. Publicidad</h2>
            <p>
              Podemos mostrar anuncios a través de Google AdSense. Google puede utilizar cookies para mostrar anuncios relevantes.
              Puedes gestionar tus preferencias de publicidad en <a href="https://adssettings.google.com/" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">la configuración de anuncios de Google</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">7. Tus Derechos</h2>
            <p>Tienes derecho a:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Acceder a tus datos personales</li>
              <li>Solicitar la eliminación de tu cuenta y datos</li>
              <li>Exportar tus datos</li>
              <li>Retirar tu consentimiento en cualquier momento</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">8. Contacto</h2>
            <p>
              Para cualquier consulta sobre privacidad, puedes contactarnos a través de nuestro sitio web.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-border text-sm text-muted-foreground">
          <Link to="/" className="text-primary hover:underline">← Volver al compresor</Link>
          {" · "}
          <Link to="/terminos" className="text-primary hover:underline">Términos de Uso</Link>
        </div>
      </main>
    </div>
  );
};

export default Privacy;
